// extracted by mini-css-extract-plugin
export default {"postContainer":"_postModal_postContainer__c-B9c","loaderWrap":"_postModal_loaderWrap__haxOS","close":"_postModal_close__bjAG9"};